import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export const shipping = {
  state: {
    list: [{
      id: 0,
      name: '',
      price: 0,
      status: '0'
    }],
    availableQuota: 0,
    status: '0',
    shippingPageView: 'ShippingList',
    region: {},
    regionList: [],
    shippingItemList: [],
    shippingType: [],
    shippingConfig: [],
    country: [],
    limit: {
      regionName: 200
    },
    link_manual: {
      th: process.env.MANUAL_URL_TH + '#shipping',
      en: process.env.MANUAL_URL_EN + '#shipping',
      vi: process.env.MANUAL_URL_VI + '#shipping'
    },
    shippingTabSelected: 'ShippingAreaDefined',
    deleteShippingItemData: []
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/shipping/index.js